<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uKS4kNhcIOYlLRFjw6rQFs5" lang="en-US"><a id="uoThBMVTm5JCLt3lRrAWJCF"></a>NOTE</p>
<p class="Perfect-Center" lang="en-US"><span class="italics">Any grammatical errors found in quoted text and testimony are attributable to the original authors and should not be considered errors by the author or publisher.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// note.vue?50f12c05